module.exports = __webpack_public_path__ + "img/515c7b6a2276470d83680be2a3776474.3bb9ef0a.jpg";